import { Component, OnInit } from '@angular/core';
import { IntlService } from '../../core/services/intl.service';
import { Subscription } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-whatsapp-cta',
  templateUrl: './whatsapp-cta.component.html',
  styleUrls: ['./whatsapp-cta.component.scss']
})
export class WhatsappCTAComponent implements OnInit {

  public supportWhatsapp;
  public subscription: Subscription;

  constructor(private intlService: IntlService) { }

  ngOnInit(): void {
    this.supportWhatsapp = this.intlService.getContactWhatsapp()?.linkNumber?.replace('00', '');

    this.subscription = this.intlService.languageChanged().subscribe(() => {
      this.supportWhatsapp = this.intlService.getContactWhatsapp()?.linkNumber?.replace('00', '');
    });
  }


}
